var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultFailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668ZM6.92226 5.74424C6.59683 5.4188 6.06919 5.4188 5.74375 5.74424C5.41832 6.06968 5.41832 6.59732 5.74375 6.92275L6.82116 8.00016L5.74375 9.07757C5.41832 9.40301 5.41832 9.93065 5.74375 10.2561C6.06919 10.5815 6.59683 10.5815 6.92226 10.2561L7.99967 9.17867L9.07709 10.2561C9.40252 10.5815 9.93016 10.5815 10.2556 10.2561C10.581 9.93065 10.581 9.40301 10.2556 9.07757L9.17819 8.00016L10.2556 6.92275C10.581 6.59732 10.581 6.06968 10.2556 5.74424C9.93016 5.4188 9.40252 5.4188 9.07709 5.74424L7.99967 6.82165L6.92226 5.74424Z",
    fill: "#F4526B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFailIcon);
export default __webpack_public_path__ + "static/media/result-fail-icon.a64495abf7b93a6b97a8f4b5bf9c921e.svg";
export { ForwardRef as ReactComponent };